
















































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Banco } from "../../typings/store/plugins/easyFirestore/bancos";
import { required } from "vuelidate/lib/validators";
import { DataFormularioBanco } from "../../typings/components/bancos/formulario";

@Component({
  validations: {
    nombre: { required },
    posicion: { required },
  },
})
export default class FormularioBanco extends Vue {
  @Prop() readonly banco!: Banco | null;
  @Prop() readonly cargando!: boolean;

  created(): void {
    const banco = this.banco;
    if (!banco) {
      return;
    }
    this.id = banco.id ?? "";
    this.nombre = banco.nombre;
    this.posicion = banco.posicion ?? "";
  }

  id: string | null = null;

  nombre = "";
  posicion = "";

  get titulo(): string {
    return this.banco ? "editar banco" : "nuevo banco";
  }

  get nombreError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.nombre.$dirty) return errors;
    if (!this.$v.nombre.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get posicionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.posicion.$dirty) return errors;
    if (!this.$v.posicion.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  @Emit("cerrar-dialogo")
  onCerrarDialogo(): void {
    return;
  }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioBanco): DataFormularioBanco {
    return data;
  }

  guardar(): void {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }
    const doc: Banco = {
      nombre: this.nombre,
      posicion: this.posicion,
    };
    if (this.id) {
      doc.id = this.id;
    }
    const data: DataFormularioBanco = {
      doc: doc,
    };
    this.onClickGuardar(data);
  }
}
